module.exports = __webpack_public_path__ + "img/bacterium.ef42cfd0.svg";